import React from 'react';
import { Link } from '../router.jsx';

export default function NotFound() {
  return (
    <div className="page not-found-page">
      <h1>Page Not Found</h1>
      <p className="subtle">The page you're looking for doesn't exist or has been moved.</p>
      <div className="not-found-actions">
        <Link to="/" className="btn btn-primary">Go Home</Link>
        <Link to="/login/staff" className="btn btn-secondary">Staff Login</Link>
        <Link to="/login/student" className="btn btn-secondary">Student Login</Link>
      </div>
    </div>
  );
}
